<template>
    <div >
        <form class="ui form segment">
            <app-header v-if="showMenu" ></app-header>
           
            <h4 class="ui header">Add Historical Data</h4>
            
            <div class="ui attached segment">
                <div class="four fields">
                    <div class="field" >
                        <label>Document Id</label>
                        <input placeholder="Document Id" name="documentid" type="text"  ref="ipDocumentId" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');" >
                    </div>
                     <div class="field" >
                        <label>Document Name</label>
                        <input placeholder="Document Name" name="documentname" type="text"  ref="ipDocumentName" >
                    </div>
                </div>
                 <div class="four fields">
                    <div class="field" >
                        <label>PO Number</label>
                        <input placeholder="PO Number" name="ponumber" type="text"  ref="ipPONumber">
                    </div>
                    <div class="field" >
                        <label>Seller Received Code</label>
                        <input placeholder="Seller Received Code" name="sellerreceivedcode" type="text"  ref="ipSellerReceivedCode">
                    </div>
                </div>
                <div class="four fields">
                    <div class="field" >
                        <label>Agency Received Code</label>
                        <input placeholder="Agency Received Code" name="agencyreceivedcode" type="text"  ref="ipAgencyReceivedCode">
                    </div>
                    <div class="field" >
                        <label>Shop Received Code</label>
                        <input placeholder="Shop Received Code" name="shopreceivedcode" type="text"  ref="ipShopReceivedCode">
                    </div>
                </div>
         
                <div class="four fields">
                    <div class="field" >
                        <label>Community Id</label>
                        <input placeholder="Community Id" name="communityid" type="text"  ref="ipCommunityId">
                    </div>
                    <div class="field" >
                        <label>Buyer Name</label>
                        <input placeholder="Buyer Name" name="buyername" type="text"  ref="ipBuyerName" >
                    </div>
                </div>
                <div class="four fields">
                    <div class="field" >
                        <label>Vendor Name</label>
                        <input placeholder="Vendor Name" name="vendorname" type="text"  ref="ipVendorName">
                    </div>
                    <div class="field" >
                        <label>Status Id</label>
                        <input placeholder="Status Id" name="statusid" type="text"  ref="ipStatusId">
                    </div>
                </div>
                <div class="four fields">
                    <div class="field" >
                        <label>Xref Flag</label>
                        <input placeholder="Xref Flag" name="xrefflag" type="text"  ref="ipXrefFlag">
                    </div>
                    <div class="field" >
                        <label>File Location Datapath</label>
                        <input placeholder="FileLocationDatapath" name="filelocationdatapath" type="text"  ref="ipFileLocationDatapath">
                    </div>
                </div>
                <div class="four fields">
                    <div class="field" >
                        <label>Cannonical Xml Datapath</label>
                        <input placeholder="Cannonical Xml Datapath" name="cannonicalxmldatapath" type="text"  ref="ipCannonicalXmlDatapath">
                    </div>
                     <div class="field" >
                        <label>Webrequest Xml Datapath</label>
                         <input placeholder="WebrequestXmlDatapath" name="Webrequestxmldatapath" type="text"  ref="ipWebrequestXmlDatapath">
                    </div>
                </div>
                 <div class="four fields">
                    <div class="field" >
                        <label>Web Response Xml Datapath</label>
                         <input placeholder="Web Response Xml Datapath" name="webresponsexmldatapath" type="text"  ref="ipWebResponseXmlDatapath">
                    </div>
                    <div class="field" >
                        <label>Document Type</label>
                        <input placeholder="Document Type" name="documentType" type="text"  ref="ipDocumentType">
                    </div>
                </div>
            </div>
            <br />
            <div class="ui primary submit button"  @click = "AddHistoricalData()">Add Historical Data</div>
        </form>
        <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/semantic-ui/2.2.2/semantic.min.css" media="screen" title="no title" charset="utf-8">
        <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/sweetalert/1.1.3/sweetalert.min.css">
    </div>
    
</template>

<script>
    import axios from "axios";
    import Header from '@/components/Header.vue';
    import Vue from 'vue'

    export default {
        components: {
        appHeader: Header
    },
    data () {
    return {
      showMenu : true,
      tokenExpired : 0,
      documentId : "",
      document_name : "",
      po_number : "",
      seller_rcv_code : "",
      agency_rcv_code : "",
      shop_rcv_code : "",
      community_id : "",
      buyer_name : "",
      vendor_name : "",
      status_id : "",
      xref_flag : "",
      file_location_datapath : "",
      cannonical_xml_datapath : "",
      webrequest_xml_datapath : "",
      webresponse_xml_datapath : "",
      doc_type : ""
      
    }
   },
    methods: {
     AddHistoricalData(){
    
    this.documentId = this.$refs.ipDocumentId.value.trim(); 
    this.document_name = this.$refs.ipDocumentName.value.trim(); 
    this.po_number = this.$refs.ipPONumber.value.trim(); 
    this.seller_rcv_code = this.$refs.ipSellerReceivedCode.value.trim(); 
    this.agency_rcv_code = this.$refs.ipAgencyReceivedCode.value.trim(); 
    this.shop_rcv_code = this.$refs.ipShopReceivedCode.value.trim(); 
    this.community_id = this.$refs.ipCommunityId.value.trim(); 
    this.buyer_name = this.$refs.ipBuyerName.value.trim(); 
    this.vendor_name = this.$refs.ipVendorName.value.trim(); 
    this.status_id = this.$refs.ipStatusId.value.trim(); 
    this.xref_flag = this.$refs.ipXrefFlag.value.trim(); 
    this.file_location_datapath = this.$refs.ipFileLocationDatapath.value.trim(); 
    this.cannonical_xml_datapath = this.$refs.ipCannonicalXmlDatapath.value.trim(); 
    this.webrequest_xml_datapath = this.$refs.ipWebrequestXmlDatapath.value.trim(); 
    this.webresponse_xml_datapath = this.$refs.ipWebResponseXmlDatapath.value.trim(); 
    this.doc_type = this.$refs.ipDocumentType.value.trim(); 

    swal({
        title: "",
        text: "Are you sure, to Insert Historical Data?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Insert it!",
        closeOnConfirm: true
      },() => {
        
            axios({ method: "POST", "url": Vue.prototype.$hostname +  "createhistoricaldata", 
                "data": {
                   documentId :  this.documentId ,
                   document_name: this.document_name ,
                   po_number : this.po_number ,
                   seller_rcv_code : this.seller_rcv_code ,
                   agency_rcv_code : this.agency_rcv_code ,
                   shop_rcv_code : this.shop_rcv_code ,
                   community_id : this.community_id ,
                   buyer_name : this.buyer_name ,
                   vendor_name : this.vendor_name ,
                   status_id : this.status_id ,
                   xref_flag : this.xref_flag ,
                   file_location_datapath : this.file_location_datapath ,
                   cannonical_xml_datapath : this.cannonical_xml_datapath ,
                   webrequest_xml_datapath : this.webrequest_xml_datapath ,
                   webresponse_xml_datapath : this.webresponse_xml_datapath ,
                   doc_type : this.doc_type 
                }, 
                 "headers": 
                  { 
                    "content-type": "application/json" ,
                    "authorization": "bearer " + sessionStorage.getItem('id_token') 
                  }  }).then
                (
                  result => {
                    sweetAlert('Data has been inserted successfully!', '', 'success')
                 }, 
                error => {
                console.error(error);
                sweetAlert('Something\'s Wrong!', error, 'error')
          
                });
        
            })
     
      
        
    }



    }
 }

</script>


// WEBPACK FOOTER //
// src/components/historical-data/AddHistoricalData.vue